// src/lib/schemas/bank-details.ts
import * as Yup from 'yup';

export const bankDetailsSchema = Yup.object().shape({
  bankName: Yup.string().required('Bank name is required'),
  accountHolderName: Yup.string()
    .min(2, 'Account holder name must be at least 2 characters')
    .max(100, 'Account holder name must not exceed 100 characters')
    .required('Account holder name is required'),
  accountNumber: Yup.string()
    .matches(/^\d{9,18}$/, 'Account number must be 9-18 digits')
    .required('Account number is required'),
  ifscCode: Yup.string()
    .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Invalid IFSC code format (e.g., SBIN0001234)')
    .required('IFSC code is required'),
  upiId: Yup.string()
    .matches(/^[\w.-]+@[\w.-]+$/, 'Invalid UPI ID format (e.g., name@upi)')
    .nullable()
    .notRequired(),
  isDefault: Yup.boolean(),
});
